export class Logger {
    logToConsole = false;

    log(data) {
        if(this.logToConsole)
            console.log(data);
    }
}